import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/services/api.service';

@Injectable({
  providedIn: 'root',
})
export class LocationsService {
  constructor(private apiService: ApiService) {}

  getLocations() {
    return this.apiService.get('locations');
  }
}
